import script from "./BulkUpdateFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkUpdateFormView.vue?vue&type=script&setup=true&lang=ts"

import "./BulkUpdateFormView.vue?vue&type=style&index=0&id=8b4532a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b4532a2"]])

export default __exports__